import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import categoryOrder from '../../constants/blogCategories';
import { makeTagPath } from '../../paths';

export function Categories({ activeCategory, hide }) {
  return (
    <div
      className={classnames('w-full pt-6 text-center overflow-auto', {
        invisible: hide,
      })}
    >
      {categoryOrder.map(({ key, name }) => (
        <Link
          key={key}
          to={key ? makeTagPath(key, 1) : '/blog/'}
          className={classnames('text-primaryDark/40 px-2 whitespace-nowrap', {
            'text-primaryDark': key === activeCategory,
          })}
        >
          {name}
        </Link>
      ))}
    </div>
  );
}
